import { render, staticRenderFns } from "./BrickMapChart.vue?vue&type=template&id=7ea0c474&scoped=true&"
import script from "./BrickMapChart.vue?vue&type=script&lang=js&"
export * from "./BrickMapChart.vue?vue&type=script&lang=js&"
import style0 from "./BrickMapChart.vue?vue&type=style&index=0&id=7ea0c474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea0c474",
  null
  
)

export default component.exports